export const isPageUrl = (url: string): boolean => !!url && url[0] === '/' && url[1] !== '/';
